import formatPrice from "@/core/helpers/formatPrice";
import useAppSelector from "@/core/helpers/useAppSelector";
import { playerInfoSelector } from "@/domains/player/slice";
import HudMoney from "@/domains/hud/components/HudMoney";

export default function HudMoneyContainer() {
  const playerInfo = useAppSelector(playerInfoSelector);

  if (!playerInfo?.character) return null;

  return (
    <div>
      <HudMoney value={formatPrice(playerInfo?.character?.money?.balance || 0)} type="cash" />
      <HudMoney
        value={formatPrice(playerInfo?.character?.money?.bank || 0)}
        type="bank"
        className="mt-1.5"
      />
    </div>
  );
}
